import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import BasicChartBlock from '@/pages/Markets/MarketsComponents/Chart/BasicChartBlock';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

type SpotChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
};
export const SpotChartBlock = ({ layout, templateChartSeries }: SpotChartBlockType) => {
  const { loading, error, chartSeries } = useChartSeries(templateChartSeries);

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='spot'
      error={error}
      layout={layout}
      loading={loading}
    />
  );
};
